<template>
    <IndexBase @auth="onAuth($event)" action="Index" controller="Mail_Log"></IndexBase>

    <Card>
        <template #title>
            <Toolbar>
                <template #left>
                    <div class="p-card-title">
                        {{ $t('mail_log') }}
                    </div>
                </template>
            </Toolbar>
        </template>
        <template #content>
            <DataTable ref="dt" responsiveLayout="scroll" class="p-datatable-sm" filterDisplay="row" sortMode="multiple"
                removableSort stateStorage="local" :stateKey="stateKey" :value="dataModel" :loading="!dataModel || loading"
                :paginator="true" :rows="10" :lazy="true" v-model:first="this.start"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 20, 50, 100, 500, 1000]"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                @state-restore="onStateRestore($event)" @page="onPage($event)" @sort="onSort($event)"
                @filter="onFilter($event)" v-model:filters="filters" :totalRecords="totalRecords" dataKey="Id">
                <Column :exportable="false" :sortable="false" headerStyle="white-space:nowrap">
                    <template #filter>
                        <Button :label="$t('clear')" icon="pi pi-filter-slash"
                            class="p-button-outlined p-button-primary p-button-sm" @click="clearFilter" :badge="filterBadge"
                            badgeClass="p-badge-danger" />
                    </template>
                    <template #body="dataModel">
                        <Button icon="pi pi-search" v-show="canView" class="p-button-rounded p-button-info mr-2 p-button-sm"
                            @click="openView(dataModel.data.Id)" />
                    </template>
                </Column>
                <Column field="Created_Date" :header="$t('created_date')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('created_date')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Ref_No" :header="$t('ref_no')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('ref_no')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Action" :header="$t('action')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('action')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Subject" :header="$t('subject')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('subject')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Mail_To" :header="$t('mail_to')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('mail_to')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Result" :header="$t('result')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('result')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Created_By" :header="$t('created_by')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('created_by')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
            </DataTable>
        </template>
    </Card>

    <Dialog :header="$t('mail_log')" v-model:visible="dialogVisible" :modal="true" :draggable="false"
        :style="{ width: '800px' }" :breakpoints="{ '960px': '90vw' }">
        <div class="p-inputtext-sm p-fluid" v-if="form">
            <div class="field grid">
                <label class="col-3">{{ $t('created_date') }}</label>
                <div class="col-9">{{ form.Created_Date }}</div>
            </div>
            <div class="field grid">
                <label class="col-3">{{ $t('ref_no') }}</label>
                <div class="col-9">{{ form.Ref_No }}</div>
            </div>
            <div class="field grid">
                <label class="col-3">{{ $t('action') }}</label>
                <div class="col-9">{{ form.Action }}</div>
            </div>
            <div class="field grid">
                <label class="col-3">{{ $t('subject') }}</label>
                <div class="col-9">{{ form.Subject }}</div>
            </div>
            <div class="field grid">
                <label class="col-3">{{ $t('mail_to') }}</label>
                <div class="col-9" style="word-break: break-all;">{{ form.Mail_To }}</div>
            </div>
            <div class="field grid">
                <label class="col-3">{{ $t('mail_cc') }}</label>
                <div class="col-9" style="word-break: break-all;">{{ form.Mail_Cc }}</div>
            </div>
            <div class="field grid">
                <label class="col-3">{{ $t('mail_bcc') }}</label>
                <div class="col-9" style="word-break: break-all;">{{ form.Mail_Bcc }}</div>
            </div>
            <div class="field grid">
                <label class="col-3">{{ $t('result') }}</label>
                <div class="col-9" style="word-break: break-all;">{{ form.Result }}</div>
            </div>
            <div class="field grid">
                <label class="col-3">{{ $t('created_by') }}</label>
                <div class="col-9">{{ form.Created_By }}</div>
            </div>
            <div class="field">
                <label>{{ $t('mail_body') }}</label>
                <iframe sandbox="" :srcdoc="form.Mail_Body"
                    style="width: 100%; height: 300px; border: 1px solid #ced4da; background: #fff;"></iframe>
            </div>
        </div>

        <template #footer>
            <Button :label="$t('close')" icon="pi pi-times" class="p-button-outlined" @click="dialogVisible = false" />
        </template>
    </Dialog>
</template>

<script>
import IndexBase from '../Helper/IndexBase.vue'

export default {
    name: "Mail_Log",
    components: {
        'IndexBase': IndexBase
    },
    data() {
        return {
            dataModel: null,
            loading: true,
            totalRecords: 0,
            start: 0,
            stateKey: this.$STATE_NAME + 'mail_log-' + this.$store.getters.getUsername,
            isAdmin: this.$store.getters.getIsAdmin,
            sorts: null,
            lazyParams: {},
            filters: null,
            stateFilters: null,
            dataUrl: "mail_log/list",
            canView: false,
            pageSize: 10,
            dialogVisible: false,
            form: null
        }
    },
    methods: {
        onAuth(event) {
            this.canView = event.canView;
        },
        onPage(event) {
            this.start = event.first;
            this.pageSize = event.rows;
            this.loadLazyData();
        },
        onSort(event) {
            this.sorts = event.multiSortMeta;
            this.loadLazyData();
        },
        onFilter() {
            this.loadLazyData();
        },
        openView(id) {
            var self = this;
            this.$emit('block-ui');

            this.$axios.get(this.$API_URL + "mail_log/" + id + "/" + this.$FORM_MODE_VIEW)
                .then((response) => {
                    self.$emit('unblock-ui');

                    if (response.data.success) {
                        self.form = response.data.data.header;
                        self.dialogVisible = true;
                    }
                    else {
                        self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: self.$DEFAULT_TIMER });
                    }
                })
                .catch(function (error) {
                    self.$emit('unblock-ui');
                    self.$toast.add({ severity: 'error', summary: "Error", detail: error.message, life: self.$DEFAULT_TIMER });
                });
        },
        loadLazyData() {
            this.loading = true;

            this.lazyParams = {
                start: this.start,
                sorts: this.dataSort,
                filters: this.dataFilter,
                pageSize: this.pageSize,
            };

            var self = this;

            this.$axios.post(this.$API_URL + this.dataUrl, this.lazyParams)
                .then((response) => {
                    if (response.data.success) {
                        this.dataModel = response.data.data;
                        this.totalRecords = response.data.totalRecords;
                    }
                    else {
                        self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: this.$DEFAULT_TIMER });
                    }

                    this.loading = false;
                })
                .catch(function (err) {
                    self.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: self.$DEFAULT_TIMER });
                    self.loading = false;
                });
        },
        setFilters() {
            this.filters = {};
            var exportable = this.$refs.dt.columns.filter(c => c.props.field);
            for (var i = 0; i < exportable.length; i++) {
                var filterValue = null;
                if (this.stateFilters) {
                    var field = this.stateFilters[exportable[i].props.field];
                    if (field) filterValue = field.value;
                }
                this.filters[exportable[i].props.field] = { value: filterValue, matchMode: "contains" };
            }
        },
        onStateRestore(event) {
            this.start = event.first;
            this.stateFilters = event.filters;
            this.sorts = event.multiSortMeta;
            this.pageSize = event.rows;
        },
        clearFilter() {
            this.filters = {};
            var exportable = this.$refs.dt.columns.filter(c => c.props.field);
            for (var i = 0; i < exportable.length; i++) {
                var fieldName = exportable[i].props.field;
                this.filters[fieldName] = { value: "", matchMode: "contains" };
            }
            this.loadLazyData();
        },
    },
    mounted() {
        this.$emit('unblock-ui');
        this.setFilters();
        this.loadLazyData();
        this.$showToast();
    },
    computed: {
        dataFilter() {
            var h = [];
            if (this.filters) {
                for (const [key, value] of Object.entries(this.filters)) {
                    h.push({
                        field: key ? key : null,
                        value: value.value,
                        matchMode: value.matchMode
                    });
                }
            }
            return h;
        },
        dataSort() {
            var h = [];
            if (this.sorts) {
                for (var x = 0; x < this.sorts.length; x++) {
                    h.push({
                        field: this.sorts[x].field,
                        order: this.sorts[x].order == 1 ? "ASC" : "DESC"
                    });
                }
            }
            return h;
        },
        filterBadge() {
            var badgeNumber = 0;

            this.dataFilter.filter(function (item) {
                if (item.value) {
                    badgeNumber++;
                }
            });

            return badgeNumber;
        }
    },
}
</script>

<style scoped>
.p-card .p-card-content {
    margin: 0 !important;
    padding: 0 !important;
}
</style>
